"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _selectors = require("./selectors");
var _view = require("../../../../actions/view");
var _PhoneSmsConfirmationInfo = require("../../../../components/PhoneSmsConfirmationInfo");
var _view2 = require("../../../../types/view");
var _agreement = require("../../../../actions/agreement");
function mapStateToProps(state) {
  return {
    phone: (0, _selectors.phoneSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    onEditPhoneClick(e) {
      e.preventDefault();
      dispatch((0, _agreement.acceptLicence)(false));
      dispatch((0, _agreement.acceptMarketingSubscription)(false));
      dispatch((0, _view.changeView)(_view2.EActiveView.PhoneAuth));
    }
  };
}
const InfoContainer = exports.InfoContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PhoneSmsConfirmationInfo.PhoneSmsConfirmationInfo);